import { Component, Input, ElementRef, OnInit, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { DygraphOptions } from './dygraphOptions';

declare const Dygraph: any;
/**
 * Wrapper arround Dygraphs
 * 
 * \@class NgxDygraphsComponent
 */
export class NgxDygraphsComponent implements OnInit, OnChanges {
public options: DygraphOptions;
public data: any;
public noDataLabel: string;
public chart: ElementRef;
public loadingInProgress: boolean;
public chartWidth: number;
public chartHeight: number;
public labels: string[];
public dygraph: any;
/**
 * @return {?}
 */
public ngOnInit() {
    this.noDataLabel =  this.noDataLabel  || 'NO DATA AVAILABLE';
    this.chartWidth = (this.options && this.options.width) || 640;
    this.chartHeight = (this.options && this.options.height) || 480;
  }
/**
 * ngOnChanges
 * \@method ngOnChanges
 * @param {?} changes
 * @return {?}
 */
public ngOnChanges(changes: SimpleChanges) {

    if (!changes) {
      return;
    }

    if (!this.data || !this.data.length) {
      this.loadingInProgress = false;
      return;
    }

    this.loadingInProgress = true;

    const /** @type {?} */ options = Object.assign({}, this.options);

    if (!options.width) { options.width = this.chartWidth; }
    if (!options.height) { options.height = this.chartHeight; }
    if (!options.legend) { options.legend = 'always'; }

    setTimeout(() => {
      this.dygraph = new Dygraph(this.chart.nativeElement,
        this.data,
        options
      );
      this.loadingInProgress = false;
      this.dygraph.ready(graph => {
        this.watchRangeSelector(graph);
      });
    }, 500);
  }
/**
 * @param {?} index
 * @param {?} value
 * @return {?}
 */
public changeVisibility(index, value) {
    this.dygraph.setVisibility(index, value);
  }
/**
 * @param {?} graph
 * @return {?}
 */
private watchRangeSelector(graph) {
    const /** @type {?} */ observer = new MutationObserver(function (mutations) { // called on style changes of range selector handles
      if (mutations.length === 2) { // both range selector handles have style changed -> assume move
        // Zoom to the same zoom to trigger zoomCallback
        const /** @type {?} */ zoomCallback = graph.getFunctionOption('zoomCallback');
        const [minX, maxX] = graph.xAxisRange();
        zoomCallback.call(graph, minX, maxX, graph.yAxisRanges());
      }
    });
    Array.from(document.getElementsByClassName('dygraph-rangesel-zoomhandle')).forEach(
      // work on range selector handles
      function (element, idx, arr) {
        // watch for style changes
        observer.observe(element, { attributes: true, attributeFilter: ['style'] });
      }
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-dygraphs',
  template: `
    <div class="ng-dygraphs">
        <div *ngIf="loadingInProgress" class="loader-holder">
            <div class="loader"></div>
        </div>
        <div class="ng-dygraphs-chart-container">
            <div [ngClass]="{'hide': !data?.length}" #chart [style.width.px]="chartWidth" [style.height.px]="chartHeight"></div>
            <div *ngIf="!data?.length" class="nodata" [style.width.px]="chartWidth" [style.height.px]="chartHeight">
              {{noDataLabel}}
            </div>
        </div>
    </div>
  `,
  styles: [`
    .ng-dygraphs {
      position: relative; }
      .ng-dygraphs .name-nodes-holder {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: row;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                flex-direction: row;
        padding-right: 30px;
        padding-left: 30px; }
      .ng-dygraphs .ng-dygraphs-chart-container {
        background-color: #fff;
        padding: 0;
        margin: 5px;}
        .ng-dygraphs .ng-dygraphs-chart-container .nodata {
          display: -ms-flexbox;
          display: -webkit-box;
          display: flex;
          -webkit-box-pack: center;
             -ms-flex-pack: center;
           justify-content: center;
         -webkit-box-align: center;
            -ms-flex-align: center;
               align-items: center;
          color: #5c5c5c;
          font-weight: bold;
          font-size: 24px; 
          display: flex;
          -ms-flex-line-pack: center;
              align-content: center; }
        .ng-dygraphs .ng-dygraphs-chart-container .hide {
           display: none; }
      .ng-dygraphs .loader-holder {
        position: absolute;
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-align: center;
            -webkit-box-align: center;
                align-items: center;
        width: 100%;
        height: 100%;
        background-color: #fff;
        z-index: 55;
        opacity: 0.9; }
      .ng-dygraphs .loader {
        color: #0dc5c1;
        font-size: 20px;
        margin: 100px auto;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        position: relative;
        text-indent: -9999em;
        -webkit-animation: load4 1.3s infinite linear;
        animation: load4 1.3s infinite linear;
        -webkit-transform: translateZ(0);
        transform: translateZ(0); }

    @-webkit-keyframes load4 {
      0%,
      100% {
        -webkit-box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
                box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0; }
      12.5% {
        -webkit-box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }
      25% {
        -webkit-box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }
      37.5% {
        -webkit-box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em; }
      50% {
        -webkit-box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em; }
      62.5% {
        -webkit-box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em; }
      75% {
        -webkit-box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
                box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0; }
      87.5% {
        -webkit-box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
                box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em; } }

    @keyframes load4 {
      0%,
      100% {
        -webkit-box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
                box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0; }
      12.5% {
        -webkit-box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }
      25% {
        -webkit-box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em; }
      37.5% {
        -webkit-box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em; }
      50% {
        -webkit-box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em; }
      62.5% {
        -webkit-box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
                box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em; }
      75% {
        -webkit-box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
                box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0; }
      87.5% {
        -webkit-box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
                box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em; } }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'options': [{ type: Input },],
'data': [{ type: Input },],
'noDataLabel': [{ type: Input },],
'chart': [{ type: ViewChild, args: ['chart', ] },],
};
}

function NgxDygraphsComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxDygraphsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxDygraphsComponent.ctorParameters;
/** @type {?} */
NgxDygraphsComponent.propDecorators;
/** @type {?} */
NgxDygraphsComponent.prototype.options;
/** @type {?} */
NgxDygraphsComponent.prototype.data;
/** @type {?} */
NgxDygraphsComponent.prototype.noDataLabel;
/** @type {?} */
NgxDygraphsComponent.prototype.chart;
/** @type {?} */
NgxDygraphsComponent.prototype.loadingInProgress;
/** @type {?} */
NgxDygraphsComponent.prototype.chartWidth;
/** @type {?} */
NgxDygraphsComponent.prototype.chartHeight;
/** @type {?} */
NgxDygraphsComponent.prototype.labels;
/** @type {?} */
NgxDygraphsComponent.prototype.dygraph;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
